(function () {
	'use strict';
	angular.module('app.setup')
		.config(function ($translateProvider) {
			$translateProvider.translations('en_us', {
				'PROJECT_TARGET': 'Area Target',
				'PROJECT_AREA': 'Area'
			});
		})
		.controller('projectArea', projectArea);

	projectArea.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', 'storeService',
		'tableService', 'leanFilterService', 'projectAreaService', 'tableRenderService'];
	function projectArea($scope, $rootScope, $timeout, $uibModal, storeService,
			tableService, leanFilterService, projectAreaService, tableRenderService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'LeanProjectAreas';
		var getSpecialControl;
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {
			'controllerName': 'projectArea'
		};

		$scope.filterService = leanFilterService;
		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddProjectArea = vm.isAdmin;
		vm.addProjectArea = addProjectArea;
		vm.deleteProjectArea = deleteProjectArea;
		vm.saveProjectArea = saveProjectArea;
		vm.saveAreaApprovers = saveAreaApprovers;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Project Areas';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		var columns = [
			{
				'id': 'name',
				'display': 'Area Name',
				'renderer': tableRenderService.projectAreaRenderer,
				'deleteFunction': 'deleteProjectArea',
				'requiredPermission': 'admin',
				'maxLength': 120,
				'width': 200,
				'allowBlank': false
			},
			{
				'id': 'approverNames',
				'display': 'Approvers',
				'renderer': tableRenderService.projectAreaRenderer,
				'requiredPermission': 'admin',
				'width': 400,
				'allowBlank': false,
				'editFunction': 'startEditProjectAreaApprovers',
				'editLabel': 'Add / Remove Approvers',
				'addPlaceholder': 'Add approvers'
			},
			{
				'id': 'target',
				'display': 'PROJECT_TARGET',
				'renderer': tableRenderService.projectAreaRenderer,
				'requiredPermission': 'admin',
				'width': 100,
				'allowBlank': true,
				'inputType': 'numeric',
				'editLabel': 'Edit Area Target'
			},
			{
				'id': 'noOfActiveLeanProjects',
				'display': '# of Active Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': urlGenerator,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true,
				'width': 100
			},
			{
				'id': 'noOfActiveSupplierProjects',
				'display': '# of Active Supplier Projects',
				'renderer': tableRenderService.integerWithLink,
				'urlGenerator': urlGenerator,
				'ndxField': 'name',
				'disableLinkForEmptyOrZero': true,
				'width': 100
			},
			{
				'id': 'noOfArchiveLeanProjects',
				'display': '# of Archive Lean Projects',
				'renderer': tableRenderService.integerWithLink,
				'ndxField': 'name',
				'width': 100,
				'disableLinkForEmptyOrZero': true,
				'urlGenerator': urlGenerator
			},
			{
				'id': 'noOfArchiveSupplierProjects',
				'display': '# of Archive Supplier Projects',
				'renderer': tableRenderService.integerWithLink,
				'ndxField': 'name',
				'width': 100,
				'disableLinkForEmptyOrZero': true,
				'urlGenerator': urlGenerator
			},
			{
				'id': 'noOfTemplates',
				'renderer': tableRenderService.integer,
				'display': '# of Project Templates',
				'width': 100
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/AreaApproversReport',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true,
			isGlobalReportSetting:true
		};

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;
		}

		function addProjectArea(projectArea) {
			var projectAreaFormScope = $scope.$new();
			projectAreaFormScope.projectType = jQuery.extend({}, projectArea);
			projectAreaFormScope.action = (typeof projectAreaFormScope.projectType.id !== 'undefined' ? 'Edit' : 'Add');
			projectAreaFormScope.leanDirFactoryNdx = adminConfig.factory.id;
			var opts = {
				scope: projectAreaFormScope,
				templateUrl: '/application/f/setup/projects/areas/project-area-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			projectAreaFormScope.closeDialog = function () {
				instance.close();
				projectAreaFormScope.$destroy();
			};

			projectAreaFormScope.result = function (message, isSuccessful) {
				$rootScope.$emit('toast', { 'message': message, 'success': isSuccessful });
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
				}
				instance.close();
				projectAreaFormScope.$destroy();
			};
		}

		function saveProjectArea(row, newContent, type) {
			var currentContent = row.name;
			var value = {};
			if (row.projectAreaNdx) value.ndx = row.projectAreaNdx;
			if (value.ndx) {
				value.factoryNdx = row.factoryNdx;
				if (type === 'target' && (newContent === null || newContent === '')) {
					newContent = 0;
				}
				if (currentContent === newContent) {
					return;
				}

				if (type === 'target') {
					value.target = newContent;
					projectAreaService.saveTarget(value, adminConfig.factory.id)
						.then(function (response) {
							handleUpdateAreaResponse(response, 'Project area target updated successfully');
						});
				} else {
					value.name = newContent;
					var lastModified = (typeof row.lastModified === 'undefined') ? (new Date()).toUTCString() : (new Date(row.lastModified)).toUTCString();
					projectAreaService.updateProjectArea(value, row.factoryNdx, lastModified)
						.then(function (response) {
							handleUpdateAreaResponse(response, 'Project area name updated successfully');
						});
				}
			}
		}

		function saveAreaApprovers(projectAreaId, newApprovers) {
			var saveObj = {
				ndx: projectAreaId,
				approversIds: newApprovers
			};

			projectAreaService.saveApprovers(saveObj, adminConfig.factory.id).then(function (response) {
				handleUpdateAreaResponse(response, 'Project area approvers updated successfully');
			});
		}

		function deleteFactoryArea(areaNdx, newAreaNdx) {
			projectAreaService.deleteArea(areaNdx, newAreaNdx, adminConfig.factory.id).then(function (response) {
				var success = false;
				var message = 'Failed to delete project area';
				if (response === 'Project area deleted successfully') {
					success = true;
					message = response;
				}
				$rootScope.$emit('toast', {
					'message': message,
					'success': success
				});
				$scope.$broadcast('reloadTable');
			});
		}

		function reassignAreaToDeletedArea(areaNdx) {
			var deleteAreaReasignScope = $scope.$new();
			deleteAreaReasignScope.selected = {};
			deleteAreaReasignScope.areaNdx = areaNdx;
			projectAreaService.getProjectAreas(adminConfig.factory.id).then(function (list) {
				deleteAreaReasignScope.areas  = _.filter(list, function (a) { return a.areaNdx !== areaNdx;});
			});

			deleteAreaReasignScope.delete = function() {
				deleteFactoryArea(deleteAreaReasignScope.areaNdx, deleteAreaReasignScope.selected.area.areaNdx);
				deleteAreaReasignScope.closeDialog();
			};

			var opts = {
				scope: deleteAreaReasignScope,
				templateUrl: '/application/f/setup/delete_area_for_project_template.html'
			};

			var instance = $uibModal.open(opts);
			deleteAreaReasignScope.closeDialog = function() {
				instance.close();
				deleteAreaReasignScope.$destroy();
			};
		}
		
		function deleteProjectArea(row) {
			if ((typeof row.noOfTemplates !== 'undefined' && row.noOfTemplates > 0) ||
				(typeof row.noOfActiveLeanProjects !== 'undefined' && row.noOfActiveLeanProjects > 0) ||
				(typeof row.noOfActiveSupplierProjects !== 'undefined' && row.noOfActiveSupplierProjects > 0) ||
				(typeof row.noOfArchiveLeanProjects !== 'undefined' && row.noOfArchiveLeanProjects > 0) ||
				(typeof row.noOfArchiveSupplierProjects !== 'undefined' && row.noOfArchiveSupplierProjects > 0)
			) {
				reassignAreaToDeletedArea(row.projectAreaNdx);
				return;
			}

			var confirmScope = $scope.$new();
			confirmScope.projectAreaId = row.projectAreaNdx;
			confirmScope.additionalText = 'delete this project area';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var projectAreaId = confirmScope.projectAreaId;
				instance.close();
				confirmScope.$destroy();
				deleteFactoryArea(projectAreaId);
			};
		}

		function urlGenerator(type, ndx, factoryNdxs, row) {
			var url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1&timePeriod=all&factory=' + adminConfig.factory.id;
			var stageIds = type.indexOf('Active') >= 0 ? row['activeStages'] : row['archiveStages'];
			if (type.indexOf('Supplier') >= 0) {
				url = '/application/f/home.html#/supply-chain/supplier-projects/?drilldown=1&timePeriod=all&factory=' + adminConfig.factory.id;
			}
			url += '&projectArea=' + ndx;
			url += '&projectStageId=' + stageIds;

			return url;
		}

		function handleUpdateAreaResponse(response, successText) {
			if (response && response.status && response.status >= 200 && response.status < 400) {
				$rootScope.$emit('toast', {
					'message': successText,
					'success': true
				});
				$scope.$broadcast('reloadTable');
			} else if (response && response.status === 412) {
				var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
				if (response && response.data && response.data.error) {
					errorMessage = response.data.error;
				}
				$rootScope.$emit('toast', {
					'message': errorMessage,
					'success': false
				});
			} else {
				var errorMessage = 'Unexpected server error';
				if (response && response.data && response.data.error) {
					errorMessage = response.data.error;
				}
				$rootScope.$emit('toast', {
					'message': (response.errorMessage ? response.errorMessage : errorMessage),
					'success': false
				});
			}
		}

		init();
	}
})();